import Parse from 'html-react-parser';

function BMP20154(props) {
    let svgCode =
    `<svg width="64" height="156" viewBox="0 0 64 156" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="82" width="56" height="70" fill="${props.darkFill}"/>
        <path d="M16 136.5L22 128L28 140L33.5 135H48" stroke="${props.highlightColour}" stroke-width="4"/>
        <line x1="20" y1="100" x2="36" y2="100" stroke="${props.highlightColour}" stroke-width="4"/>
        <line x1="22" y1="100" x2="22" y2="116" stroke="${props.highlightColour}" stroke-width="4"/>
        <path d="M50 100L35 110.392L35 89.6077L50 100Z" fill="${props.highlightColour}"/>
    </svg>`

    props.svgReturn(48, svgCode, "bmp00154", 64, 156);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20154;